import {
    DELETE_POINT_OF_INTEREST,
    DELETE_POINT_OF_INTEREST_FAILURE,
    DELETE_POINT_OF_INTEREST_SUCCESS,
} from 'store/actions/types';

export const deletePointOfInterest = (payload) => {
    return {
        type: DELETE_POINT_OF_INTEREST,
        payload: payload,
    };
};

export const deletePointOfInterestFailure = (error) => {
    return {
        type: DELETE_POINT_OF_INTEREST_FAILURE,
        error: error,
    };
};

export const deletePointOfInterestSuccess = (payload, response) => {
    return {
        type: DELETE_POINT_OF_INTEREST_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/pointsofinterest/deletePointsOfInterest.js